import React from "react";
import { useLocation } from "react-router-dom";
import Fade from "react-reveal/Fade";
import Button from "elements/Button";
import BrandIcon from "parts/IconText";

export default function Header() {
  const location = useLocation();

  const getNavLinkClass = (path) => {
    return location.pathname === path ? " active" : "";
  };

  return (
    <header className="spacing-sm">
      <div className="container ">
        <Fade>
          <nav className="navbar fixed-top navbar-expand-lg bg-white shadow-sm">
            <div className="container-fluid col-lg-10 px-4 d-flex justify-content-between align-items-center">
              
              {/* Brand di sebelah kiri */}
              <BrandIcon />

              {/* Toggle di kanan */}
              <button
                className="navbar-toggler ms-auto"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* Menu di kanan */}
              <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                <ul className="navbar-nav mb-2 mb-lg-0 text-center text-lg-end">
                  <li className={`nav-item${getNavLinkClass("/")}`}>
                    <Button className="nav-link" type="link" href="/">
                      Beranda
                    </Button>
                  </li>
                  <li className={`nav-item${getNavLinkClass("/about")}`}>
                    <Button className="nav-link" type="link" href="/about">
                      Tentang Kami
                    </Button>
                  </li>
                  <li className={`nav-item${getNavLinkClass("/products")}`}>
                    <Button className="nav-link" type="link" href="/products">
                      Produk Kami
                    </Button>
                  </li>
                  <li className={`nav-item${getNavLinkClass("/contact")}`}>
                    <Button className="nav-link" type="link" href="/contact">
                      Kontak
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </Fade>
      </div>
    </header>
  );
}
